import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchResultsService {
  isSearchResultVisible: BehaviorSubject<boolean> = new BehaviorSubject(false);

  shouldOpenSearch: BehaviorSubject<boolean> = new BehaviorSubject(false);

  isSearchResultVisible$: Observable<boolean> = this.isSearchResultVisible.asObservable();
  openSearch$: Observable<boolean> = this.shouldOpenSearch.asObservable();
}
